export enum RoleType {
    AM = 0,
    VM, // Viewer,
    GM, // Manager
}
